import { ApiRequest } from './fetcher';

type httpClientMethodProps = {
	conditions?: { version?: string; auth?: boolean; form?: boolean };
	url?: string;
	config?: any;
	body?: any;
};

export class HTTPClient {
	name: string;
	constructor(name: string) {
		this.name = name;
	}

	getUrl(url = '') {
		return `${this.name}${url}`;
	}

	get({ conditions = {}, url = '', config = {} }: httpClientMethodProps) {
		return ApiRequest.getInstance(conditions).get(this.getUrl(url), config);
	}

	post({ conditions = {}, url = '', body, config = {} }: httpClientMethodProps) {
		return ApiRequest.getInstance(conditions).post(this.getUrl(url), body, config);
	}

	patch({ conditions = {}, url = '', body }: httpClientMethodProps) {
		return ApiRequest.getInstance(conditions).patch(this.getUrl(url), body);
	}

	put({ conditions = {}, url = '', body }: httpClientMethodProps) {
		return ApiRequest.getInstance(conditions).put(this.getUrl(url), body);
	}

	delete({ conditions = {}, url = '', body }: httpClientMethodProps) {
		return ApiRequest.getInstance(conditions).delete(this.getUrl(url), body);
	}
}
